import PASentry from "util/pa-sentry";
import { getNextQuery } from "./getNextQuery";
import { LinkProps } from "./urlHelper";

interface IGetLinkProps {
  url: string;
  href?: string;
}
export function getLinkProps({ url, href = "/[pathname]" }: IGetLinkProps): LinkProps {
  const [, query] = url.split("?");
  const nextQuery = getNextQuery(query);
  if (!url || url === "undefined") {
    PASentry.logException(new Error("aspath is undefined"), null, {
      url, href, nextQuery, getLinkProps: true, getLinkPropsType: typeof url,
    });
  }
  return {
    href: nextQuery.length ? `${href}?${nextQuery}` : "[pathname]",
    as: url,
  };
}
